import { Component, OnInit } from "@angular/core";
import { BaseService } from "../base.service";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-language",
  templateUrl: "./language.component.html",
  styleUrls: ["./language.component.css"],
})
export class LanguageComponent implements OnInit {
  constructor(
    private pagesService: BaseService,
    private route: ActivatedRoute,
    public translate: TranslateService
  ) {}
  subcategory: any = [];
  apiParam = { slug: "", limit: 10, offset: 0 };
  shimarStatus = true;

  loadMore: boolean;
  genereData: any = {};
  noRecordStatus = true;

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.route.params.subscribe((params) => {
      if (params["slug"]) {
        this.apiParam.slug = params["slug"];
        this.apiParam.offset = 0;
      }
      this.getData();
    });
  }

  getData() {
    this.loadMore = true;
    this.pagesService.getDataByLanguage(this.apiParam).subscribe(
      (data: any) => {
        this.genereData = data.results;
        this.subcategory = this.subcategory.concat(data.results.subcategory);
        this.subcategory.forEach((element) => {
          if (element.content.length > 0 && this.noRecordStatus === true) {
            this.noRecordStatus = false;
          }
        });
        this.shimarStatus = false;
        this.loadMore = false;
      },
      (err: any) => {
        this.shimarStatus = false;
        this.loadMore = false;
      }
    );
  }

  onScroll() {
    if (this.subcategory.length > 0) {
      this.apiParam.offset += 15;
      this.getData();
      this.loadMore = false;
    }
  }
}
